module.exports = __webpack_public_path__ + "img/message.68444eae.svg";